export interface FirmwareUpdateDevice {
  mac: string;
  apiKey?: string;
  status: string;
  progress: number;
  currentPacket: number;
  totalPackets: number;
  error?: string;
  rejectionReason?: string;
  installedVersion?: string;
  startedAt?: Date;
  completedAt?: Date;
}

export interface FirmwareUpdateJob {
  jobId: string;
  status: string;
  firmwareFile: string;
  firmwareVersion: string;
  firmwareCrc: number;
  firmwareType: string;
  devices: FirmwareUpdateDevice[];
  createdBy: string;
  createdAt: Date;
  updatedAt: Date;
  completedAt?: Date;
}

export interface QueueDevice {
  mac: string;
  apiKey: string;
  firmwareType: string;
  status: string;
  firmwareVersion: string;
  originalJobId: string;
  force: boolean;
  progress: number;
  currentPacket: number;
  totalPackets: number;
  error?: string;
  rejectionReason?: string;
  addedAt?: Date;
  startedAt?: Date;
  completedAt?: Date;
}

export interface FirmwareFile {
  fileName: string;
  filePath: string;
  version: string;
  firmwareType: string;
}

export interface RejectedSelection {
  mac: string;
  reason: string;
}

export interface StartUpdateResponse {
  success: boolean;
  batchId?: string;
  totalDevices?: number;
  rejected?: RejectedSelection[];
  firmwareVersion?: string;
  firmwareType?: string;
  devices?: FirmwareUpdateDevice[];
  reason?: string;
}

export interface FirmwareVersionOption {
  version: string;
  isCurrent: boolean;
}

export type ModalityKey = 'same' | 'toDataBus' | 'toZigbee';

export interface ModalityOption {
  key: ModalityKey;
  firmwareType: string;
  label: string;
  versions: FirmwareVersionOption[];
  warning?: boolean;
}

export interface DeviceOptions {
  mac: string;
  blocked: boolean;
  blockedReason?: string;
  modalities: ModalityOption[];
}

export interface FirmwareSelection {
  mac: string;
  firmwareType: string;
  version: string;
}

export interface PanelDevice {
  _id: string;
  mac: string;
  apiKey: string;
  name: string;
  account: string;
  type: string;
  isCommunicator: boolean;
  firmVersion: string;
  firmwareType: string;
  hasZigbeeModule?: boolean;
  companyName: string;
  companyId: string;
  active: boolean;
  selected?: boolean;
  updateStatus?: 'up_to_date' | 'outdated' | 'unknown';
  // Estado transitorio de UI para el selector de modalidad/versión (CI-2800)
  deviceOptions?: DeviceOptions;
  selectedModalityKey?: ModalityKey;
  selectedVersion?: string;
}

export interface CompanyOption {
  _id: string;
  name: string;
}

export const RESTART_WAIT_DEFAULT_SECONDS = 120;
export const RESTART_WAIT_MIN_SECONDS = 30;
export const RESTART_WAIT_MAX_SECONDS = 900;

export interface DeviceFilters {
  company?: string;
  apiKey?: string;
  mac?: string;
  page: number;
  limit: number;
}

export interface DevicesResponse {
  success: boolean;
  data: PanelDevice[];
  total: number;
  page: number;
  limit: number;
}
